(() => {
  'use strict';
  const states = new WeakMap();
  const videos = new Set();
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = Boolean(navigator.connection?.saveData);
  const updateButton = (video, state) => {
    if (!state.button || !video.isConnected) return;
    const playing = !video.paused;
    state.button.textContent = playing ? state.button.dataset.pauseLabel : state.button.dataset.playLabel;
    state.button.setAttribute('aria-pressed', String(playing));
    state.button.setAttribute('aria-label',state.button.textContent + ': ' + state.button.dataset.videoTitle);
    state.button.removeAttribute('aria-busy');
  };
  const sync = video => {
    const state = states.get(video);
    if (!state) return;
    if (!video.isConnected) { video.pause(); observer.unobserve(video); videos.delete(video); return; }
    const allowed = state.userStarted || !state.manual && !reduce.matches && !saveData;
    if (state.visible && !document.hidden && !video.closest('[hidden]') && !state.userPaused && allowed) {
      if (!video.paused) return;
      state.autoStarting = true;
      video.play().catch(() => updateButton(video,state)).finally(() => { state.autoStarting = false; });
    } else if (!video.paused) { state.autoPausing = true; video.pause(); }
  };
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    const state = states.get(entry.target);
    if (state) { state.visible = entry.isIntersecting; sync(entry.target); }
  }), {threshold:0.15});
  const register = (video, button = null) => {
    if (!video || states.has(video)) return states.get(video);
    const state = {visible:false, userPaused:false, userStarted:false, manual:Boolean(button), autoPausing:false, autoStarting:false, button};
    states.set(video,state); videos.add(video);
    video.muted = true; video.loop = true; video.playsInline = true;
    video.addEventListener('play', () => {
      if (!state.autoStarting) { state.userStarted = true; state.userPaused = false; }
      updateButton(video,state);
    });
    video.addEventListener('pause', () => {
      if (!state.autoPausing && state.visible) state.userPaused = true;
      state.autoPausing = false; updateButton(video,state);
    });
    observer.observe(video);
    return state;
  };
  const mount = scope => {
    scope.querySelectorAll?.('.lh-primary-video').forEach(video => register(video));
    scope.querySelectorAll?.('[data-lh-card-media]').forEach(card => {
      const button = card.querySelector('[data-lh-video-toggle]');
      const template = card.querySelector('template[data-lh-card-video]');
      const stage = card.querySelector('[data-lh-card-video-stage]');
      const poster = card.querySelector('.lh-card-static');
      if (!button || !template || !stage || button.dataset.ready) return;
      button.dataset.ready = 'true';
      const failed = expectedVideo => {
        const video = stage.querySelector('video');
        if (expectedVideo && video !== expectedVideo) return;
        if (video) { observer.unobserve(video); videos.delete(video); video.pause(); }
        stage.replaceChildren(); stage.hidden = true;
        if (poster) poster.hidden = false;
        button.textContent = button.dataset.errorLabel;
        button.setAttribute('aria-label',button.textContent + ': ' + button.dataset.videoTitle);
        button.setAttribute('aria-pressed','false'); button.removeAttribute('aria-busy');
      };
      button.addEventListener('click', () => {
        let video = stage.querySelector('video');
        if (!video) {
          stage.append(template.content.cloneNode(true));
          video = stage.querySelector('video');
          if (!video) { failed(); return; }
          stage.hidden = false;
          register(video,button);
          video.addEventListener('loadeddata', () => { if (poster && stage.querySelector('video') === video) poster.hidden = true; }, {once:true});
          video.addEventListener('error',() => failed(video),{once:true});
        }
        const state = states.get(video);
        if (video.paused) {
          state.userStarted = true; state.userPaused = false;
          button.textContent = button.dataset.loadingLabel; button.setAttribute('aria-busy','true');
          video.play().then(() => { if (stage.querySelector('video') === video) updateButton(video,state); }).catch(error => { if (error.name === 'AbortError' && state.userPaused) updateButton(video,state); else failed(video); });
        } else { state.userPaused = true; video.pause(); }
      });
    });
  };
  mount(document);
  document.addEventListener('lh:video-ready',event => register(event.detail?.video));
  document.addEventListener('shopify:section:load',event => mount(event.target));
  document.addEventListener('shopify:section:unload',() => videos.forEach(sync));
  document.addEventListener('visibilitychange',() => videos.forEach(sync));
  reduce.addEventListener('change',() => videos.forEach(sync));
})();
